// @flow
export { default as AdminPages } from './AdminPages';
export { default as ChangeAdminPage } from './ChangeAdminPage';